import React, { useEffect, useRef, useState } from 'react'
import { PaginaType, SearchResults } from 'utils/types'
import { Button, WContainer } from 'components/atoms'
import { Page } from 'components/organisms'
import styles from './RicercaTemplate.module.sass'
import { SearchResultItem } from '@components/molecules'
import { Reload } from '@components/atoms/Icons'
import useTrans from '@hooks/useTrans'
import { useSearchLazyQuery } from '@gql/graphql'
import { RICERCA_ELEMENTS_PER_PAGE } from 'utils/settings'
import uniqBy from 'lodash/uniqBy'

interface Props {
  pagina: PaginaType
  query: string
  risultati: SearchResults
}

const RicercaTemplate = (props: Props) => {
  const { pagina, query, risultati } = props

  const mounted = useRef(false)

  const t = useTrans()

  const [risultatiInfinite, setRisultatiInfinite] = useState({
    edges: [],
    pageInfo: { endCursor: null },
  })
  const [page, setPage] = useState(1)
  const [paginator, setPaginator] = useState({ first: RICERCA_ELEMENTS_PER_PAGE })
  const [refetch, { data, loading }] = useSearchLazyQuery({
    skip: !query,
    variables: {
      query,
      ...paginator,
    },
    fetchPolicy: 'cache-first',
  })

  const loadMore = () => {
    const endCursor = risultatiInfinite?.pageInfo?.endCursor || risultati?.pageInfo?.endCursor
    if (endCursor) {
      setPage(page + 1)
      setPaginator({
        first: RICERCA_ELEMENTS_PER_PAGE,
        after: endCursor,
      })
    }
  }

  useEffect(() => {
    if (!mounted.current) {
      mounted.current = true
    } else if (query) {
      refetch()
    }
  }, [paginator])

  useEffect(() => {
    if (!loading && data?.search) {
      let searchResults = Object.assign({}, data.search)
      searchResults.edges = uniqBy(
        risultatiInfinite?.edges?.concat(data.search.edges.map((item) => item.node)),
        'url'
      )
      setRisultatiInfinite(searchResults)
    }
  }, [loading, data])

  const hasOtherPages = risultati?.totalCount / RICERCA_ELEMENTS_PER_PAGE >= page

  return (
    <Page pagina={pagina} item={pagina} className={styles.page}>
      <div className={styles.ricercaTemplate}>
        <WContainer>
          <div className={styles.wrap}>
            {!!pagina?.titolo && (
              <h1 className={styles.title} dangerouslySetInnerHTML={{ __html: pagina.titolo }} />
            )}
            {risultati?.edges?.length > 0 && (
              <div className={styles.list}>
                {risultati.edges.map((x) => (
                  <SearchResultItem
                    item={x}
                    key={`${x.modelName}_${x.object.pk}`}
                    className={styles.item}
                  />
                ))}
                {risultatiInfinite?.edges?.map((x) => (
                  <SearchResultItem
                    item={x}
                    key={`${x.modelName}_${x.object.pk}`}
                    className={styles.item}
                  />
                ))}
              </div>
            )}
            {hasOtherPages && (
              <div className={styles.more}>
                <Button
                  label={t('Carica altri')}
                  icon={<Reload />}
                  iconPos="right"
                  variant="ghost"
                  className={styles.moreButton}
                  onClick={loadMore}
                />
              </div>
            )}
          </div>
        </WContainer>
      </div>
    </Page>
  )
}

export default RicercaTemplate
